import React from 'react'

import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import CachedView from 'common/builder/components/chart/FlowChart/nodes/shared/CachedView/CachedView'
import { text } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'

import { ItemStyle } from './SplitVariant.styles'

interface SplitVariantProps {
  id: string
  percent: number
  title: string
  nextStep: FlowChartNextStep
}

export const SplitVariant = ({ id, percent, title, nextStep }: SplitVariantProps) => {
  return (
    <CachedView style={{ display: 'flex', alignItems: 'center' }} id={id} key={id}>
      <view style={ItemStyle}>
        <richtext style={text} text={title} />
        <richtext style={text} text={`${percent}%`} />
      </view>
      <NextStep nextStep={nextStep} />
    </CachedView>
  )
}
